import PropTypes from 'prop-types'
import Head from 'next/head'
import dynamic from 'next/dynamic'

import Error from '@shared/components/error'
import NoIndexNoFollow from '@shared/components/no-index-follow'
import useTheme from '@shared/hooks/useTheme'
import ClientCommonNav from '@shared/components/commonNav/client'
import { useEffect, useState } from 'react'
import { FIXTURES_LIST } from '@graphql/series/fixtures.query'
import { useLazyQuery } from '@apollo/client'
import { fixtureLoader, tableLoader } from '@shared/libs/allLoader'
import { useRouter } from 'next/router'
import { GET_ROUNDS, GET_STANDING_DATA } from '@graphql/series/standings.query'
import todayStyle from '../detail/style.module.scss'
import { FETCH_SERIES_STATS_TYPE, STATS } from '@graphql/series/stats.query'

// import Logo from '@assets/images/logo-color.svg'
// import MyImage from '@shared/components/myImage'

const FixturesItems = dynamic(() => import('@shared/components/series/fixturesItems'), { loading: () => fixtureLoader() })
const Standings = dynamic(() => import('@shared/components/series/standings'), { loading: () => tableLoader() })
const Stats = dynamic(() => import('@shared/components/series/stats'), { loading: () => tableLoader() })

function DHFixtureList({ upcoming, iSeriesId, matchStatus, appName }) {
  useTheme()
  const router = useRouter()
  const [activeTab, setActiveTab] = useState(matchStatus)
  const [eSubType, setSubType] = useState('stBmr')
  const [getFixture, { data }] = useLazyQuery(FIXTURES_LIST, {
    fetchPolicy: 'network-only'
  })
  const [getRound, { data: round }] = useLazyQuery(GET_ROUNDS)
  const [getStanding, { data: standing }] = useLazyQuery(GET_STANDING_DATA)
  const [getType, { data: seriesTypes }] = useLazyQuery(FETCH_SERIES_STATS_TYPE)
  const [getStats, { data: seriesStats }] = useLazyQuery(STATS, { fetchPolicy: 'no-cache' })
  async function handleTabChange(e) {
    if (e === 'pointsTable') {
      getRound({
        variables: {
          input: {
            iSeriesId: iSeriesId
          }
        }
      })
      getStanding({
        variables: {
          input: {
            iSeriesId: iSeriesId,
            iRoundId: null
          }
        }
      })
    } else if (e === 'stats') {
      const { data: d } = await getType({ variables: { input: { eGroupTitle: 'All' } } })
      const s = d?.fetchSeriesStatsTypes?.find((e) => e?.eSubType === 'stBmr')
      getStats({ variables: { input: { iSeriesId, _id: s?._id } } })
    } else {
      getFixture({
        variables: {
          input: {
            iSeriesId: iSeriesId,
            nOrder: 1,
            sSortBy: 'dStartDate',
            sStatusStr: e
          }
        }
      })
    }
    setActiveTab(e)
  }

  function handleClick(value) {
    router.push(`/iframe/detail/?iMatchId=${value?._id}&isPreviewMode=true&appName=${appName}`)
  }

  function getColors() {
    if (appName === 'spl') {
      return `
         --theme-color-medium:#5C0083;
            --bs-primary-rgb: 92, 0, 131;
            --bs-info-rgb: 222, 204, 230;
            --theme-light: #5c008333;
            --theme-color-light: #5c008333;
        `
    } else if (appName === 'bpl') {
      return `
        --theme-color-medium: #0249c9;
       `
    } else {
      return `
         --theme-color-medium:#334B2B;
            --bs-primary-rgb: 51, 75, 43;
            --bs-info-rgb: 173, 191, 182;
            --theme-light: #334B2B61;
            --theme-color-light: #334B2B;
        `
    }
  }

  useEffect(() => {
    let interval
    if (activeTab === 'live') {
      interval = setInterval(() => {
        getFixture({
          variables: {
            input: {
              iSeriesId: iSeriesId,
              nOrder: 1,
              sSortBy: 'dStartDate',
              sStatusStr: 'live'
            }
          }
        })
      }, 6000)
    }
    return () => {
      interval && clearInterval(interval)
    }
  }, [activeTab])
  return (
    <>
      <Head>
        <title>{matchStatus === 'scheduled' ? 'Fixtures' : 'Results'}</title>
        <style>{`
           [data-mode="light"] {
            ${getColors()}
            }
            table th {background-color: var(--theme-color-medium);}
            .dropdown-menu a {pointer-events: all !important}
        `}</style>
        {/* <style></style> */}
        <NoIndexNoFollow />
      </Head>
      <div className={`container py-3 ${todayStyle.main}`}>
        <ClientCommonNav
          items={[
            { navItem: 'Upcoming', internalName: 'scheduled' },
            { navItem: 'Live', internalName: 'live' },
            { navItem: 'Completed', internalName: 'completed' },
            { navItem: 'Points Table', internalName: 'pointsTable' },
            { navItem: 'Stats', internalName: 'stats' }
          ]}
          active={activeTab}
          onTabChange={handleTabChange}
          // isSticky
        />
        {activeTab !== 'pointsTable' && activeTab !== 'stats' && (
          <>
            {/* {loading && fixtureLoader()} */}
            {(data?.fetchFixuresData || upcoming)?.map((fixture) => {
              return (
                <FixturesItems key={fixture._id} fixture={fixture} className="fixture-box-DH" isDailyHuntMode handleClick={handleClick} />
              )
            })}
          </>
        )}
        {activeTab === 'pointsTable' && round && standing && (
          <Standings
            round={round?.fetchSeriesRounds}
            // category={category?.data}
            // id={category?.data?.iSeriesId}
            standing={standing?.fetchSeriesStandings}
          />
        )}
        {activeTab === 'stats' && (
          <Stats
            data={seriesStats}
            matchTypeData={[]}
            typeData={seriesTypes}
            id={iSeriesId}
            // category={category}
            isDailyHunt
            onTypeChange={(e) => {
              setSubType(e?.eSubType)
              // getStats({ variables: { input: { iSeriesId, _id: e?._id, iTeamId: e?.iTeamId } } })
            }}
            seoData={{ eSubType: eSubType }}
          />
        )}
        {/* {upcoming?.length === 0 && <p className='text-center'>No Data found</p>} */}
      </div>
    </>
  )
}

DHFixtureList.propTypes = {
  iSeriesId: PropTypes.string.isRequired,
  matchStatus: PropTypes.string,
  upcoming: PropTypes.array,
  appName: PropTypes.string
}

export default Error(DHFixtureList)

export async function getServerSideProps({ res, params, query, resolvedUrl }) {
  res.setHeader('Cache-Control', 'public, max-age=120')
  try {
    const { iSeriesId, appName = 'v' } = query

    if (!iSeriesId) return { notFound: true }

    const queryGraphql = (await import('@shared-components/queryGraphql')).default
    const { FIXTURES_LIST } = await import('@graphql/series/fixtures.query')

    const { data: fixture } = await queryGraphql(FIXTURES_LIST, {
      input: { iSeriesId, nOrder: 1, sSortBy: 'dStartDate', sStatusStr: 'live' }
    })
    if (fixture?.fetchFixuresData?.length) {
      return { props: { upcoming: fixture?.fetchFixuresData, iSeriesId, matchStatus: 'live', appName } }
    } else {
      const { data: upcoming } = await queryGraphql(FIXTURES_LIST, {
        input: { iSeriesId, nOrder: 1, sSortBy: 'dStartDate', sStatusStr: 'scheduled' }
      })
      if (upcoming?.fetchFixuresData?.length) {
        return { props: { upcoming: upcoming?.fetchFixuresData, iSeriesId, matchStatus: 'scheduled', appName } }
      } else {
        const { data: completed } = await queryGraphql(FIXTURES_LIST, {
          input: { iSeriesId, nOrder: 1, sSortBy: 'dStartDate', sStatusStr: 'completed' }
        })
        return { props: { upcoming: completed?.fetchFixuresData, iSeriesId, matchStatus: 'completed', appName } }
      }
    }
  } catch (e) {
    res.setHeader('Cache-Control', 'no-cache')
    const handleApiError = (await import('@shared/utils')).handleApiError
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
